import $ from 'jquery';
import giftSlider from '../modules/gift';

export default() => {
    (function (tab, $) {
        var $dom = {};
        var cacheDom = function cacheDom() {
            $dom.tabEle = $('.delete_routine');
            $dom.tabPanel = $('.tab-pane');
        };

        var selectTab = function selectTab() {
            $dom.tabEle.on('click', function (e) {
                e.preventDefault();
                var $this = $(this);
                $dom.tabEle.removeClass('active');
                $this.addClass('active');
                $dom.tabPanel.removeClass('active');
                $('#custom_product_' + $this.attr('data-step')).addClass('active');
                $('#custom_product_' + $this.attr('data-step') + ' input[type="radio"]').prop('checked', false);
                $('.gift-product-' + $this.attr('data-step') + '-image').html('');
                $('.gift-product-id-' + $this.attr('data-step')).val('');
                // $('.gift-products').slick('unslick');
                // let x = $('.custom-gift-wrapper').offset();
                // $("html, body").animate({scrollTop : x.top},700);
            });
        };
        tab.init = function () {
            cacheDom();
            selectTab();
        };
    })(window.tab = window.tab || {}, $, undefined);
};